import type { RowSkin } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

// Default look for the shared neutral folder row (deskUi/rowTemplates/
// FolderRow). Surfaces spread it into their RowSkin (`folder: { ...
// defaultFolderRowSkin }`) and may override individual keys; a surface that
// wants a fully different folder look (gallery, forum) simply supplies its
// own token block instead.
export const defaultFolderRowSkin: NonNullable<RowSkin['folder']> = {
  row: 'flex flex-col gap-0.5 px-1 py-1.5',
  head: 'flex min-w-0 items-center gap-1.5',
  title: 'min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[13px]',
  time: 'flex-[0_0_auto] whitespace-nowrap text-[12px] text-[#888]',
  text: 'min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-[13px] text-[#888]',
  counts: 'flex flex-wrap gap-x-2 text-[12px] text-[#888]',
  count: 'whitespace-nowrap',
}
